// extracted by mini-css-extract-plugin
export default {"root":"ik877NG43dfTLxNuXiF_","langSwitcher":"s131aD8hATI6xqpg0ZEl","orig":"GHl9GKJrRQPpuFlvjBDt","hover":"QVLTIY7iOORjBZq1635_","placeHolderShimmer":"O8hEs8GzFlQq_b3aH9HP"};